import axios from '../core/axios';
import { ApiConstants } from './api-constants';

export enum ViewTypeEnum {
  mine = 'mine',
  all = 'all',
}

export type GetBusinessesQueryParamsType = {
  view: ViewTypeEnum;
  search?: string;
  category?: string;
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  pageSize?: number;
  refresh?: boolean;
};

export class BusinessesService {
  static getBusinesses = async (params?: GetBusinessesQueryParamsType) => {
    return await (
      await axios.get(ApiConstants.BUSINESSES_API.GET_BUSINESSES.URL(), { params })
    ).data;
  };
  static getBusinessById = async (businessId: string) => {
    return await (
      await axios.get(ApiConstants.BUSINESSES_API.GET_BUSINESS_BY_ID.URL(businessId))
    ).data;
  };
  static getBusinessDeals = async (businessId: string, params: any) => {
    return await (
      await axios.get(ApiConstants.BUSINESSES_API.GET_BUSINESS_DEALS.URL(businessId), { params })
    ).data;
  };
  static getBusinessIntel = async (businessId: string) => {
    return await (
      await axios.get(ApiConstants.BUSINESSES_API.GET_BUSINESS_INTEL.URL(businessId))
    ).data;
  };
  static followBusiness = async (businessId: string) => {
    return await (
      await axios.post(ApiConstants.BUSINESSES_API.FOLLOW_BUSINESS.URL(businessId))
    ).data;
  };
  static unfollowBusiness = async (businessId: string) => {
    return await (
      await axios.delete(ApiConstants.BUSINESSES_API.FOLLOW_BUSINESS.URL(businessId))
    ).data;
  };
  static getBusinessNews = async (businessId: string, page: number) => {
    return await (
      await axios.get(ApiConstants.BUSINESSES_API.GET_BUSINESS_NEWS.URL(businessId), {
        params: { page },
      })
    ).data;
  };
  static getSimilarCompanies = async (businessId: string) => {
    return await (
      await axios.get(ApiConstants.BUSINESSES_API.GET_SIMILAR_COMPANIES.URL(businessId))
    ).data;
  };
  static getPlatformInsights = async (businessId: string) => {
    return await (
      await axios.get(ApiConstants.BUSINESSES_API.GET_PLATFORM_INSIGHTS.URL(businessId))
    ).data;
  };
  static getContacts = async (
    businessId: string,
    params: {
      page: number;
      limit: number;
      search: string;
    },
  ) => {
    return await (
      await axios.get(ApiConstants.BUSINESSES_API.GET_CONTACTS.URL(businessId), { params })
    ).data;
  };
  static saveToMyContacts = async (businessId: string, payload: { zoominfoPersonId: string }) => {
    return await (
      await axios.post(
        ApiConstants.BUSINESSES_API.POST_CONTACT_TO_MY_CONTACTS.URL(businessId),
        payload,
      )
    ).data;
  };
  static addTarget = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.BUSINESSES_API.POST_BUSINESS_TARGET.URL(), payload)
    ).data;
  };
  static removeTarget = async (id: string) => {
    return await (
      await axios.delete(ApiConstants.BUSINESSES_API.DELETE_TARGET.URL(id))
    ).data;
  };
  static getZoomInfoSearchResults = async (params?: { q: string }) => {
    return await (
      await axios.get(ApiConstants.BUSINESSES_API.GET_ZOOMINFO_SEARCH_RESULTS.URL(), { params })
    ).data;
  };
  static getZoomInfoRecentSearch = async () => {
    return await (
      await axios.get(ApiConstants.BUSINESSES_API.GET_ZOOMINFO_SEARCH_RECENT.URL())
    ).data;
  };
  static addZoomInfoRecentSearch = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.BUSINESSES_API.POST_ZOOMINFO_SEARCH_RECENT.URL(), payload)
    ).data;
  };
}
